import {saveData, getData, clearData, findByID} from "../db/db_helper"

//load from DB
export const getWorkspace = async () =>{
    return await getData("workspace") || []
}

export const saveWorkspace = async (obj) =>{
    saveData("workspace", obj)
}